import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash.get';
import { OFFSET_INTEGRATED_DR_HEIGHT } from '../constants/constants';

export const PaymentCalculatorButton = ({
	isLoanLeaseAvailable,
	isScrollingSidebar,
	isMobile,
	prefs,
	labels
}) => {
	const handleButtonClick = () => {
		if (isMobile) {
			const pubsub = get(window, 'pubsub', undefined);
			if (pubsub) {
				pubsub.publish('openDRTools', 'payment');
				return;
			}
		}

		const headerSelector =
			document &&
			document.querySelector('[data-widget-id="template-navigation1"]');
		const scrollToSelector = '[data-widget-id="digital-retailing-1"]';
		const pageHeaderHeight =
			(headerSelector && headerSelector.clientHeight) || 0;

		/* eslint no-undef: 0 */
		if (DDC && DDC.scrollToAnchor) {
			DDC.scrollToAnchor($(scrollToSelector), {
				heightAdj: pageHeaderHeight + OFFSET_INTEGRATED_DR_HEIGHT
			});
		}
	};

	const renderButton = () => {
		const {
			paymentCalculatorButtonLabel,
			paymentCalculatorButtonClasses,
			paymentCalculatorButtonIcon,
			paymentCalculatorButtonIconClasses,
			paymentBoxBackground,
			paymentBoxPadding
		} = prefs;

		let buttonWrapperClasses = [`py-${paymentBoxPadding}`];

		if (!isScrollingSidebar) {
			let applyBoxPadding;
			let applyBoxBackground;
			const bottomPaddingClasses = `pb-${paymentBoxPadding}`;

			if (isLoanLeaseAvailable) {
				applyBoxPadding = `px-${paymentBoxPadding}`;
				applyBoxBackground = paymentBoxBackground;
			}

			buttonWrapperClasses = [
				'payment-calculator-wrapper',
				applyBoxBackground,
				applyBoxPadding,
				bottomPaddingClasses
			];
		}

		return (
			<div>
				{/* 
				  * React needs the outer DOM element to render the className for the following div
				  * This could be a possible bug with react. 
				  * Note: This div could be removed if the display of this component is controlled by a server side rendered element.
				  * Site properties are right now rendered in the browser side.
				 */}
				<div className={buttonWrapperClasses.filter(Boolean).join(' ')}>
					<button
						className={`btn btn-${paymentCalculatorButtonClasses} w-100`}
						onClick={handleButtonClick}
					>
						<i
							className={`ddc-icon ddc-icon-${paymentCalculatorButtonIcon} ${paymentCalculatorButtonIconClasses}`}
						/>
						{labels.get(paymentCalculatorButtonLabel)}
					</button>
				</div>
			</div>
		);
	};

	return renderButton();
};

PaymentCalculatorButton.propTypes = {
	isLoanLeaseAvailable: PropTypes.bool.isRequired,
	isScrollingSidebar: PropTypes.bool.isRequired,
	isMobile: PropTypes.bool.isRequired,
	prefs: PropTypes.shape({
		paymentCalculatorButtonLabel: PropTypes.string,
		paymentCalculatorButtonClasses: PropTypes.string,
		paymentCalculatorButtonIcon: PropTypes.string,
		paymentCalculatorButtonIconClasses: PropTypes.string,
		paymentBoxBackground: PropTypes.string,
		paymentBoxPadding: PropTypes.string
	}).isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func.isRequired
	}).isRequired
};

export default PaymentCalculatorButton;



// WEBPACK FOOTER //
// ./src/components/PaymentCalculatorButton.jsx